import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormControlLabel,
  Switch,
  Grid,
  Typography,
  Alert,
  Checkbox,
} from '@mui/material';

const GenerateCardForm = ({ onGenerate }) => {
  const [quantity, setQuantity] = useState(1);
  const [useRandomPoints, setUseRandomPoints] = useState(false);
  const [fixedPoints, setFixedPoints] = useState(10);
  const [minPoints, setMinPoints] = useState(10);
  const [maxPoints, setMaxPoints] = useState(100);
  const [sendToPrinting, setSendToPrinting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (useRandomPoints && minPoints >= maxPoints) {
      setError('Minimum points must be less than maximum points');
      return;
    }

    try {
      const data = useRandomPoints
        ? { quantity, minPoints, maxPoints, sendToPrinting }
        : { quantity, fixedPoints, sendToPrinting };
      await onGenerate(data);
    } catch (err) {
      setError(err.message || 'Failed to generate loyalty cards');
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="number"
            label="Quantity"
            value={quantity}
            onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value)))}
            InputProps={{ inputProps: { min: 1 } }}
          />
        </Grid>
        
        {/* <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={useRandomPoints}
                onChange={(e) => setUseRandomPoints(e.target.checked)}
              />
            }
            label="Use Random Points Range"
          />
        </Grid> */}

        {useRandomPoints ? (
          <>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                label="Minimum Points"
                value={minPoints}
                onChange={(e) => setMinPoints(parseInt(e.target.value))}
                InputProps={{ inputProps: { min: 1 } }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                label="Maximum Points"
                value={maxPoints}
                onChange={(e) => setMaxPoints(parseInt(e.target.value))}
                InputProps={{ inputProps: { min: minPoints } }}
              />
            </Grid>
          </>
        ) : (
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Fixed Points"
              value={fixedPoints}
              onChange={(e) => setFixedPoints(parseInt(e.target.value))}
              InputProps={{ inputProps: { min: 1 } }}
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={sendToPrinting}
                onChange={(e) => setSendToPrinting(e.target.checked)}
                color="primary"
              />
            }
            label="Send to Printing"
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
          >
            Generate Loyalty Cards
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default GenerateCardForm;